<template>
  <div>
    <b-modal
      :id="content.idHTML"
      content-class="px-1 px-md-3 py-0"
      header-class="pt-1 pb-0"
      footer-class="px-1 px-md-3 pt-0 pb-2"
      centered
      hide-header-close
      no-fade
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header>
        <h3 class="texte-noir text-left" v-html="content.titre"></h3>
      </template>
      <div>
        <div class="body-3 texte-noir text-left" v-html="content.message" />
      </div>
      <template #modal-footer>
        <b-row class="d-flex flex-row-reverse">
          <b-button
            class="w-xs-auto w-md-auto px-4 float-right"
            variant="modal"
            @click="fermerModale()"
          >
            {{ content.libBoutonContinuer }}
          </b-button>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'ModaleInformation',
  props: {
    content: { type: Object, required: true },
  },
  methods: {
    fermerModale() {
      this.$emit('close');
    },
  },
};
</script>
